import React from 'react';
import { LuClock3, LuPlay, LuSparkles } from 'react-icons/lu';

const VIDEO_SRC = '/media/nithuja-ad.mp4';
const VIDEO_POSTER = '/images/gallery/wedding-cake2.jpg';

const highlights = [
  {
    icon: LuSparkles,
    label: 'Handcrafted details with a premium finish'
  },
  {
    icon: LuPlay,
    label: 'A quick 8-second glimpse of our cake-making magic'
  },
  {
    icon: LuClock3,
    label: 'Perfect inspiration before you place your order'
  }
];

const PromoVideoSection = () => (
  <section className="relative overflow-hidden bg-white py-20 px-4 sm:px-6 lg:px-8" aria-label="Brand advertisement video">
    <div className="ad-video-backdrop" aria-hidden="true" />
    <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 items-center relative z-10">
      <div className="space-y-6">
        <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.45em] text-pink-600 uppercase">
          <span className="h-px w-8 bg-pink-200" aria-hidden="true" />
          Featured
        </span>

        <h2 className="text-3xl sm:text-4xl font-serif font-bold text-gray-900">
          A Sweet Peek into Nithuja Cakes
        </h2>

        <p className="text-lg text-gray-600">
          Watch how a simple idea becomes a show-stopping cake — smooth swirls, delicate flowers, and the final
          premium touch that makes every celebration feel special.
        </p>

        <ul className="space-y-3">
          {highlights.map(({ icon: Icon, label }) => (
            <li key={label} className="flex items-start gap-3 text-gray-700">
              <span className="mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded-full bg-pink-50 text-pink-600">
                <Icon className="h-5 w-5" aria-hidden="true" />
              </span>
              <span>{label}</span>
            </li>
          ))}
        </ul>

        <div className="flex flex-wrap gap-4 pt-4">
          <a
            href="#order"
            className="inline-flex items-center justify-center rounded-full bg-pink-600 px-6 py-3 text-white font-semibold shadow-lg hover:bg-pink-700 transition"
          >
            Order Now
          </a>

          <a
            href="#gallery"
            className="inline-flex items-center justify-center rounded-full border border-gray-300 px-6 py-3 font-semibold text-gray-800 hover:bg-gray-50 transition"
          >
            View Cake Gallery
          </a>
        </div>

      </div>

      <div className="relative">
        <div className="ad-video-shell">
          <span className="ad-video-ring" aria-hidden="true" />
          <span className="ad-video-orb ad-video-orb-one" aria-hidden="true" />
          <span className="ad-video-orb ad-video-orb-two" aria-hidden="true" />
          <video
            className="w-full h-full rounded-[32px] object-cover"
            src={VIDEO_SRC}
            poster={VIDEO_POSTER}
            autoPlay
            muted
            loop
            playsInline
            controls
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  </section>
);

export default PromoVideoSection;
